export default __webpack_public_path__ + "static/media/benefit3.dedc0da6.svg";